import React, { useEffect, useRef } from 'react';
import './volume.scss';

let tvScriptLoadingPromise = null;

export default function Volume() {
  const containerRef = useRef(null);

  useEffect(() => {
    // Load script TradingView hanya sekali
    if (!tvScriptLoadingPromise) {
      tvScriptLoadingPromise = new Promise((resolve) => {
        const script = document.createElement('script');
        script.id = 'tradingview-widget-loading-script';
        script.src = 'https://s3.tradingview.com/tv.js';
        script.type = 'text/javascript';
        script.onload = resolve;
        document.head.appendChild(script);
      });
    }

    tvScriptLoadingPromise.then(() => {
      // Pastikan script TradingView sudah load dan div container ada
      if (!window.TradingView || !containerRef.current) return;

      new window.TradingView.widget({
        container_id: 'tradingview_4fbee',
        autosize: true,
        symbol: 'IDX:DATA',
        interval: 'D',
        timezone: 'Etc/UTC',
        theme: 'light',
        style: '1',
        locale: 'en',
        allow_symbol_change: true,
      });
    });
  }, []);

  return (
    <div className="containerVolume">
      <h3>Stock Price & Volume</h3>

      <div className="tradingview-widget-container" style={{ width: '100%' }}>
        <div id="tradingview_4fbee" ref={containerRef} style={{ height: '60vh', width: '100%' }} />
      </div>
    </div>
  );
}
